import React from "react"

export const MapContext = React.createContext()

export const MapProvider = MapContext.Provider
export const MapConsumer = MapContext.Consumer
